<template>
  <div class="hero-section-form">
    <div class="form-group mb-3">
      <label>輪播速度 (毫秒)</label>
      <input
        type="number"
        class="form-control"
        v-model.number="localData.autoplay_speed"
      />
    </div>

    <hr class="horizontal dark my-3" />
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="mb-0">幻燈片管理 (Slides)</h6>
      <button
        type="button"
        class="btn btn-primary mb-0"
        @click="showManager = true"
      >
        <i class="fas fa-images me-1"></i> 管理幻燈片 (Manage Slides)
      </button>
    </div>
    <div class="alert alert-light border">
      <small class="text-muted"
        ><i class="fas fa-info-circle me-1"></i>
        點擊上方按鈕開啟管理視窗，可新增、編輯、刪除及排序幻燈片。圖片上傳時將強制裁剪為
        16:9 比例。</small
      >
    </div>

    <HeroSlideManager :show="showManager" @close="showManager = false" />
  </div>
</template>

<script>
import HeroSlideManager from "./HeroSlideManager.vue";

export default {
  name: "HeroSectionEditor",
  components: {
    HeroSlideManager,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        slides: [],
        autoplay_speed: 5000,
        style: "full_screen",
      }),
    },
  },
  data() {
    return {
      localData: { ...this.modelValue },
      showManager: false,
    };
  },
  watch: {
    localData: {
      handler(val) {
        this.$emit("update:modelValue", val);
      },
      deep: true,
    },
    modelValue: {
      handler(val) {
        // Sync primitive values if changed from parent (though usually parent updates from us)
        if (val.autoplay_speed !== this.localData.autoplay_speed) {
          this.localData.autoplay_speed = val.autoplay_speed;
        }
      },
      deep: true,
    },
  },
};
</script>
